import React from 'react';
import CreativeApp from '../CreativeApp';

export default function CreativeEntry() {
  return <CreativeApp />;
}
